<div class="report-content">

	<div class="row mb-4">
		<div class="col-12">
			<ms-report-date-filter
				mode="asOf"
				[(asOfDate)]="asOfDate"
				[disabled]="isLoading()"
				(applied)="onDateChanged()" />
		</div>
	</div>

	@if (errorMessage()) {
		<div class="alert alert-danger" role="alert">
			<fa-duotone-icon icon="triangle-exclamation" class="me-2" />
			{{ errorMessage() }}
		</div>
	}

	@if (!errorMessage() && !isBalanced() && report()) {
		<div class="alert alert-warning" role="alert">
			<fa-duotone-icon icon="triangle-exclamation" class="me-2" />
			Debits and credits do not match. Please contact support if this issue persists.
		</div>
	}

	@if (isLoading() && !report()) {
		<div class="text-center py-5">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</div>
	}

	@if (report(); as data) {
		<table class="table table-sm trial-balance-table">
			<thead>
				<tr>
					<th scope="col" class="tb-col-account">Acct No.</th>
					<th scope="col" class="tb-col-description">Account Description</th>
					<th scope="col" class="tb-col-debit text-end">Debit</th>
					<th scope="col" class="tb-col-credit text-end">Credit</th>
				</tr>
			</thead>
			<tbody>
				@if (groupedRows().length === 0) {
					<tr>
						<td colspan="4" class="text-center text-muted py-4">No activity for the selected date.</td>
					</tr>
				}

				@for (group of groupedRows(); track group.label) {
					<tr class="tb-group-header" [attr.data-accent]="group.accent">
						<td colspan="4" class="fw-semibold">
							<fa-duotone-icon [icon]="group.icon" secondaryOpacity="0.7" class="me-2 tb-group-icon" />
							{{ group.label }}
						</td>
					</tr>
					@for (row of group.rows; track row.account.chartOfAccountId) {
						<tr class="tb-data-row">
							<td class="tb-col-account">{{ row.account.accountNumber }}</td>
							<td class="tb-col-description">
								{{ row.account.name }}
								@if (!row.account.isActive) {
									<span class="badge bg-warning-subtle text-warning-emphasis ms-1">Retired</span>
								}
							</td>
							<td class="tb-col-debit text-end" [class.tb-has-value]="row.debitAmount > 0">
								@if (row.debitAmount > 0) {
									<span class="d-inline d-sm-none tb-mobile-label">Dr</span>{{ formatAmount(row.debitAmount) }}
								}
							</td>
							<td class="tb-col-credit text-end" [class.tb-has-value]="row.creditAmount > 0">
								@if (row.creditAmount > 0) {
									<span class="d-inline d-sm-none tb-mobile-label">Cr</span>{{ formatAmount(row.creditAmount) }}
								}
							</td>
						</tr>
					}
				}
			</tbody>
			<tfoot>
				<tr class="tb-totals-row">
					<td class="tb-totals-spacer"></td>
					<td class="tb-totals-label fw-semibold">Totals</td>
					<td class="tb-col-debit text-end fw-semibold">
						<span class="d-inline d-sm-none tb-mobile-label">Dr</span>{{ formatAmount(data.totalDebits) }}
					</td>
					<td class="tb-col-credit text-end fw-semibold">
						<span class="d-inline d-sm-none tb-mobile-label">Cr</span>{{ formatAmount(data.totalCredits) }}
					</td>
				</tr>
			</tfoot>
		</table>
	}

</div>
